import { DateTime } from "luxon";

// Type for YAML-based events (from EventYaml GraphQL type)
export interface YamlEvent {
  id: string;
  yamlId?: string;
  title: string;
  organizer: string;
  venue: string;
  startAt: string;
  createdAt: string;
  endAt: string;
  url: string;
  time_tbd?: boolean;
  image?: {
    imgix?: {
      url?: string;
    };
  } | null;
}

export default class Event {
  id: string;
  title: string;
  organizer: string;
  venue: string | null;
  image: any; // Flexible type to handle YAML image structures
  startAt: DateTime;
  createdAt: DateTime;
  endAt: DateTime;
  url: string;
  dateLabel: string;
  time_tbd: boolean;

  constructor(event: YamlEvent) {
    this.id = event.id;
    this.title = event.title!;
    this.organizer = event.organizer!;
    this.venue = event.venue!.length > 0 ? event.venue! : null;
    this.image = event.image as any;
    this.url = event.url!;
    this.time_tbd = event.time_tbd ?? false;
    this.startAt = DateTime.fromISO(event.startAt!).setZone("Asia/Tokyo");
    this.endAt = DateTime.fromISO(event.endAt!).setZone("Asia/Tokyo");
    this.createdAt = DateTime.fromISO(event.createdAt!).setZone("Asia/Tokyo");

    if (this.time_tbd) {
      // 時間未定の場合は日付と曜日のみ表示
      if (this.startAt.hasSame(this.endAt, "day")) {
        this.dateLabel = `${this.startAt.toFormat("yyyy.MM.dd")} (${
          this.startAt.setLocale("ja").weekdayShort
        }) 時間未定`;
      } else {
        this.dateLabel = `${this.startAt.toFormat("yyyy.MM.dd")} (${
          this.startAt.setLocale("ja").weekdayShort
        }) - ${this.endAt.toFormat("yyyy.MM.dd")} (${
          this.endAt.setLocale("ja").weekdayShort
        }) 時間未定`;
      }
    } else {
      // 通常の時間表示
      if (this.startAt.hasSame(this.endAt, "day")) {
        this.dateLabel = `${this.startAt.toFormat("yyyy.MM.dd")} (${
          this.startAt.setLocale("ja").weekdayShort
        }) ${this.startAt.toFormat("HH:mm")} - ${this.endAt.toFormat("HH:mm")}`;
      } else {
        this.dateLabel = `${this.startAt.toFormat("yyyy.MM.dd")} (${
          this.startAt.setLocale("ja").weekdayShort
        }) - ${this.endAt.toFormat("yyyy.MM.dd")} (${
          this.endAt.setLocale("ja").weekdayShort
        })`;
      }
    }
  }
}
